//angular
import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, DecimalPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
//others
import { NgxCleaveDirectiveModule } from "ngx-cleave-directive";
import { NgxJsonViewerModule } from 'ngx-json-viewer';
//app modules
import { AppMaterialModule } from '../../app.material';
import { AppSharedModule } from 'src/app/_shared/app.shared.module';
import { MainRoutingModule } from './main.routing';
import { SharedModule } from './_shared/shared.module';
//app directives
import { HoverDirective } from './_shared/directives/hover.directive';
import { TwoDigitDecimalNumberDirective } from 'src/app/_shared/directives/decimal.directive';
//app components
import { DashboardComponent } from './dashboard/dashboard.component';
import { DialogBulkComponent } from './_shared/dialog/bulk/bulk.component';
import { DialogConfirmationComponent } from './_shared/dialog/confirmation/confirmation.component';
import { DialogMessageTimerComponent } from './_shared/dialog/message-timer/message-timer.component';
import { LayoutBaseComponent } from './layout.component';
import { LayoutBaseNewComponent } from './layout-new.component';
import { NavMobileComponent } from './_shared/nav-mobile/nav-mobile.component';
import { PanelHelpComponent } from './_shared/panel-help/panel-help.component';
//Rebillia library components
import { RebNgxCardModule } from '@rhinosaas/reb-ngx/reb-ngx-card';
import { RebNgxChartFallbackModule } from '@rhinosaas/reb-ngx/reb-ngx-chart-fallback';
import { RebNgxHeadingLabelModule } from '@rhinosaas/reb-ngx/reb-ngx-heading-label';
import { RebNgxIconModule } from '@rhinosaas/reb-ngx/reb-ngx-icon';
import { RebNgxGlobalBannerModule } from '@rhinosaas/reb-ngx/reb-ngx-global-banner';
import { RebNgxBannerModule } from '@rhinosaas/reb-ngx/reb-ngx-banner';
import { RebNgxLabelModule } from '@rhinosaas/reb-ngx/reb-ngx-label';
import { RebNgxLineChartModule } from '@rhinosaas/reb-ngx/reb-ngx-line-chart';
import { RebNgxMatButtonModule } from '@rhinosaas/reb-ngx/reb-ngx-mat-button';
//client components
import { BillingOperationDashboardComponent } from './dashboard/billing-operation/billing-operation-dashboard.component';
import { BillingOperationChartComponent } from './dashboard/billing-operation/billing-operation-chart.component';
import { SalesChannelsDashboardComponent } from './dashboard/sales-channels/sales-channels-dashboard.component';
import { StorePerformanceComponent } from './dashboard/store-performance/store-performance.component';

const COMPONENTS: any[] = [
  BillingOperationChartComponent,
  BillingOperationDashboardComponent,
  DashboardComponent,
  HoverDirective,
  LayoutBaseComponent,
  LayoutBaseNewComponent,
  NavMobileComponent,
  PanelHelpComponent,
  SalesChannelsDashboardComponent,
  StorePerformanceComponent,
  TwoDigitDecimalNumberDirective,
]

const DIALOGS: any[] = [
  DialogBulkComponent,
  DialogConfirmationComponent,
  DialogMessageTimerComponent,
]

const MODULES: any[] = [
  AppMaterialModule,
  AppSharedModule,
  CommonModule,
  FormsModule,
  MainRoutingModule,
  NgxCleaveDirectiveModule,
  NgxJsonViewerModule,
  RebNgxChartFallbackModule,
  RebNgxGlobalBannerModule,
  RebNgxBannerModule,
  RebNgxCardModule,
  RebNgxLabelModule,
  RebNgxMatButtonModule,
  RebNgxHeadingLabelModule,
  RebNgxIconModule,
  RebNgxLineChartModule,
  SharedModule,
]

const PROVIDERS: any[] = [
  CurrencyPipe,
  DecimalPipe,
]

@NgModule({
    declarations: [COMPONENTS, DIALOGS ],
    exports: [LayoutBaseComponent],
    imports: [MODULES],
    providers: [PROVIDERS]
})

export class MainModule {
  constructor() {
    console.log(`main.module.ts was loaded.`)
  }
}
